
<style scoped lang="scss">
.commission-wrapper {
	background: $white;
	.nav-row {
		width: 100%;
		padding: 0.586667rem 0.533333rem 2.533333rem 0.533333rem;
		background: url("https://oss.tuoxingwang.com/vaporetto-assets/user/commission/commission-back.png")
			0 0 no-repeat;
		background-size: 100% 100%;
		.nav {
			display: flex;
			justify-content: space-between;
			.each-nav {
				padding: 0.106667rem 0.373333rem;
				text-align: center;
				color: $white;
				font-family: PingFang SC;
				font-size: 0.373333rem;
				font-weight: 400;
				border-radius: 0.4rem;
				transition: 0.2s ease;
				&.active {
					background: rgba(255, 255, 255, 1);
					box-shadow: 0px 2px 6px rgba(247, 153, 28, 0.71);
					border-radius: 0.4rem;
					font-size: 0.373333rem;
					font-weight: bold;
					line-height: 0.533333rem;
					color: #f8b356;
				}
			}
		}
		.order-nav {
			font-weight: 400;
			line-height: 0.453333rem;
			font-size: 12px;
			img {
				width: 0.4rem;
				height: 0.4rem;
				margin-right: 0.08rem;
				position: relative;
				top: 2px;
			}
		}
	}
	.commission-card {
		margin: -1.826667rem 0.533333rem 1.093333rem 0.533333rem;
		.total-card {
			background: $white;
			padding: 0.693333rem 0.426667rem 0.293333rem;
			box-shadow: 0px 0.053333rem 0.213333rem rgba(173, 173, 173, 0.25);
			border-radius: 0.266667rem;
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			.wallet {
				width: 100%;
				margin-top: 0.026667rem;
				margin-bottom: 0.213333rem;
				padding-bottom: 0.053333rem;
				border-bottom: 1px solid #ebebeb;
				font-size: 0.746667rem;
				font-weight: bold;
				line-height: 1.066667rem;
				text-align: center;
				color: #ff9200;
				.wallet-symbol {
					font-size: 0.533333rem;
				}
			}
			.acount-wra {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 0.24rem;
				width: 100%;
				font-size: 0.426667rem;
				font-weight: 500;
				line-height: 0.586667rem;
				color: #444444;
				img {
					margin-right: 0.16rem;
					width: 0.533333rem;
					height: 0.533333rem;
				}
			}
			.acount--number-wra {
				display: flex;
				justify-content: space-around;
				width: 100%;
				font-size: 0.373333rem;
				font-weight: 400;
				line-height: 0.533333rem;
				color: #454545;
				.acount-number-left,
				.acount-number-center,
				.acount-number-right {
					text-align: center;
				}
				.number {
					margin-top: 0.053333rem;
					font-size: 0.373333rem;
					font-weight: 400;
					line-height: 0.533333rem;
					color: #ff9200;
				}
			}
			p {
				font-size: 14px;
				color: $white;
			}
		}
		.order-btn {
            display: flex;
            align-items: center;
            justify-content: center;
			margin-top: 0.613333rem;
			font-size: 0.373333rem;
			font-weight: 400;
			line-height: 0.533333rem;
			color: #333333;
            img{
                width: 0.586667rem;
                height: 0.586667rem;
            }
		}
	}
}
</style>

<template>
	<div class="commission-wrapper">
		<div class="nav-row">
			<nav class="nav">
				<div class="each-nav" @click="changeData(0,'total')" :class="{'active':activeIndex===0}">全部</div>
				<div class="each-nav" @click="changeData(1,'today')" :class="{'active':activeIndex===1}">今日</div>
				<div class="each-nav" @click="changeData(2,'week')" :class="{'active':activeIndex===2}">近七天</div>
				<div class="each-nav" @click="changeData(3,'thisMonth')" :class="{'active':activeIndex===3}">本月</div>
				<div class="each-nav" @click="changeData(4,'lastMonth')" :class="{'active':activeIndex===4}">上月</div>
			</nav>
		</div>
		<div class="commission-card">
			<div class="total-card" v-cloak>
				<div class="acount-wra">
					<img :src="list1Src" alt="img" />
					<span>累计佣金</span>
				</div>
				<div class="wallet">
					<span class="wallet-symbol">￥</span>
					<span v-text="currData.total"></span>
				</div>
				<div class="acount--number-wra">
					<div class="acount-number-left">
						<div>待入账</div>
						<div class="number">￥{{currData.tobeGet}}</div>
					</div>
					<div class="acount-number-center">
						<div>待结算</div>
						<div class="number">￥{{currData.toBeSettled}}</div>
					</div>
					<div class="acount-number-right">
						<div>已结算</div>
						<div class="number">￥{{currData.settled}}</div>
					</div>
				</div>
			</div>
			<div class="order-btn" @click="redirectToList">
				<span>查看订单明细</span>
				<img :src="rightGrayArrow" alt="img" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "UserCommission",
	components: {},
	props: {},
	data() {
		return {
			activeIndex: 0,
			currData: {},
			current: "today",
			orderIconSrc: "",
			list1Src: "",
			rightGrayArrow: ""
		};
	},
	computed: {
		totalCMS() {
			return (
				Number(this.currData.already || 0) +
				Number(this.currData.future || 0)
			);
		}
	},
	watch: {},
	created() {
        this.getCommissionData();
        wx.ready(function () {
            UTILS.hiddenMenu();
        });
	},
	mounted() {
		this.orderIconSrc = API.ossUrl + "user/commission/order-icon.png";
		this.list1Src = API.ossUrl + "user/commission/list-1.png";
		this.rightGrayArrow = API.ossUrl +"common/right-gray-arrow-two.png";
	},
	destroyed() {},
	methods: {
		changeData(i, which) {
			this.activeIndex = i;
			this.current = which;
			this.getCommissionData();
		},
		redirectToList() {
			this.$router.push({
				name: "userCommissionList"
			});
		},
		getCommissionData() {
			this.$axios
				.get(
					`${window.API.user.commission}/${this.activeIndex}?token=${sessionStorage.token}`
				)
				.then(({ data }) => {
					if (data.code == 200) {
						this.currData = data.data;
					} else {
						this.$toast(data.msg);
					}
				})
				.catch(err => console.log(err));
		}
	}
};
</script>
